<template>
  <footer class="editorial-footer">
    <div class="editorial-container">
      <section v-if="showNewsletter" class="newsletter-section" aria-labelledby="newsletter-title">
        <div>
          <h2 id="newsletter-title">
            Get new articles
            <br />
            <em>by email.</em>
          </h2>
          <p>I send tips, new articles, and workshop dates from time to time.</p>
        </div>
        <FooterSubscribeForm />
      </section>
      <div class="footer-directory">
        <div class="footer-signoff">
          <EditorialWordmark />
          <p>I write about testing and web development.</p>
          <a href="mailto:filip@filiphric.com">Say hello ↗</a>
        </div>
        <FooterAbout />
        <FooterSitemap />
        <FooterSocialIcons />
      </div>
      <div class="footer-bottom editorial-label">
        <span>© {{ year }} Filip Hric</span>
        <a href="#main-content">Back to top ↑</a>
      </div>
    </div>
  </footer>
</template>
<script setup lang="ts">
withDefaults(defineProps<{ showNewsletter?: boolean }>(), { showNewsletter: true })
const year = new Date().getFullYear()
</script>
